import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => {
  return {
    cardHeaderButton: {
      color: '#006cfc',
      borderColor: '#006cfc',
    },
    newTokenButton: {
      color: '#2b3990',
      borderColor: '#2b3990',
    },
    modalText: {
      fontSize: 14,
      color: '#1a334d',
    },
    removeTokensButton: {
      color: '#ef5350',
      borderColor: '#ef5350',
    },
    actionsButtons: {
      display: 'flex',
      flexDirection: 'row-reverse',
      marginTop: '16px',
      gap: '15px',
    },
    confirmDeleteTitle: {
      color: '#b71c1c',
      fontSize: 16,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    confirmDeleteText: {
      color: '#263238',
      fontSize: 14,
      fontWeight: 'normal',
      textAlign: 'center',
      paddingTop: theme.spacing(1.5),
    },
    newTokenTitle: {
      color: '#263238',
      fontSize: 14,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    newTokenAlert: {
      color: '#263238',
      fontSize: 12,
      fontWeight: 'normal',
      textAlign: 'center',
    },
    newTokenText: {
      color: '#263238',
      fontSize: 14,
      fontWeight: '500',
      textAlign: 'center',
      background: 'rgb(247, 248, 248)',
      padding: theme.spacing(1.5),
      overflowWrap: 'break-word',
      marginTop: theme.spacing(1.5),
      borderRadius: 5,
      fontFamily: 'Vazir',
      direction: 'rtl',
    },
    cancelDeleteButton: {
      background: '#b71c1c',
      color: 'white',
      borderColor: '#b71c1c',
      marginInlineEnd: theme.spacing(2),
      paddingInlineEnd: theme.spacing(3),
      paddingInlineStart: theme.spacing(3),
      '&:hover': {
        background: '#a41111',
        color: 'white',
      },
    },
    detailPaper: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(2.5),
      boxSizing: 'border-box  ',
    },
  };
});
